/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://nfv5qyg4b5hjdiszohpmzlhxe4.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-tnggghmjbrefvmg3e6zy77cu7q",
    "aws_cognito_identity_pool_id": "us-east-1:8c598f47-416b-4686-8697-a3f3f83b2842",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_5WJyZXmdd",
    "aws_user_pools_web_client_id": "75mr3uko5uvhvihmp94mfdicpa",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "vimcarbrokerwebnew6bda3bf8f79d40e2ad97392eb1ae1cdd61-prodstable",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
